import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/reset.svg'


const _withScopeId = n => (_pushScopeId("data-v-eaa6d834"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full flex flex-col relative text-sub text-sm" }
const _hoisted_2 = { class: "flex w-full text-xs sm:text-sm flex-wrap" }
const _hoisted_3 = { class: "sm:w-6 w-4 text-end" }
const _hoisted_4 = { class: "sm:w-6 w-4 text-end" }
const _hoisted_5 = { class: "sm:w-6 w-4 text-end" }
const _hoisted_6 = { class: "sm:w-6 w-4 text-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-5 font-normal"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "translate-y-0"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "translate-y-0"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "translate-y-0"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 3,
  class: "translate-y-0"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-[#E9E9E9] border-solid border-b h-1 bg-blue-00" }, null, -1))

import router from '@/router';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useStore } from 'vuex';
import locations from '@/assets/data/location.json'
import MobileFilter from '@/components/Serach/MobileFilter.vue'
import { splitLocation } from '@/utils/formattedUnit';
import SpeciesFilter from './SpeciesFilter.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeFilter',
  emits: ['resetToggle'],
  setup(__props, { emit: __emit }) {

const closeBtn = () => {
    store.commit('SET_MOBILE_SPEICES_MODAL', false)
}
const store = useStore();
const genderArr = ['미구분', '암컷', '수컷', '한쌍', '그룹']
const sizeArr = ['베이비','아성체','준성체','성체']
const locationArr = ['서울','경기','인천','강원','충북','충남','세종','대전','경북','경남','대구','울산','부산','전북','전남','광주','제주'];
const priceArr = ['~10만원','10~50만원','50~100만원','100~500만원','500~1,000만원','1,000만원 이상']

const tempFilter = computed(()=> store.state.temporaryFilter);
const isLoading = computed(()=> store.state.isLoading);
const handleMobileSpecies = computed( () => store.state.mobileSpeicesModal);
const selectedSpecies = computed(() => store.state.selectedSpecies)
const popupOpen = ref(false)
const popupFilter = ref(null)
const locationDetailArr = ref([]); // "강남구","강동구","강북구","강서구","관악구",

onMounted(() => {
    // resetFilter();
    tempFilter.value.toggle = false
})
onUnmounted(() => {
    const resetValues = {
    price: '',
    location: '',
    gender: '',
    size: '',
    city : '',
    town : '',
    toggle : false,
  };
    store.commit('SET_TEMPORARY_FILTER', resetValues);
});
// watch(handleMobileSpecies, (newVal) => {
//   if (newVal) {
//     // `on-screen` 상태일 때 body 스크롤 비활성화
//     console.log('hidden wathcing')
//     document.body.style.overflow = 'hidden';
//   } else {
//     // `off-screen` 상태일 때 body 스크롤 활성화
//     document.body.style.overflow = '';
//   }
// });
const handleSpeices = () => {
    // store.commit('SET_MOBILE_SPEICES_MODAL', true)
    store.commit('SET_MOBILE_SPEICES_MODAL', !handleMobileSpecies.value)
    // console.log(handleMobileSpecies.value)
}


const handlePopup = (type:string) => {
    if(popupFilter.value !== type){
        popupFilter.value = type
        tempFilter.value.toggle = true
        // console.log(tempFilter.value)
        // console.log(popupFilter.value)
    } else if (type === 'location'){
        tempFilter.value.toggle = false
        popupFilter.value = null;

    } else {
        tempFilter.value.toggle = false
        popupFilter.value = null;

    }
    // popupOpen.value = !popupOpen.value
    popupOpen.value = false;

}


const setGender = ( btn :string) => {
    
    const value = { gender : btn}
    if(tempFilter.value.gender === btn){
        store.commit('SET_TEMPORARY_FILTER', {gender : ''});
    } else {
        store.commit('SET_TEMPORARY_FILTER', value);
    }
}
const setSize = (btn:string) => {
    const value = { size : btn}
    if(tempFilter.value.size === btn){
        store.commit('SET_TEMPORARY_FILTER', {size : ''});
    } else {
        store.commit('SET_TEMPORARY_FILTER', value);
    }
}


const setCity = (btn:string) => {
    const value = {
        city : btn,
        town : '',
    }
    store.commit('SET_TEMPORARY_FILTER', value);
    locationDetailArr.value = locations[tempFilter.value.city]
    // console.log(tempFilter.value.location)
    // console.log(locations[tempFilter.value.location])
}
const setTown = (btn:string) => {
    const value = {town : btn}
    store.commit('SET_TEMPORARY_FILTER', value);
}

const setPrice = (btn:string) => {
    const value = { price : btn}
    if(tempFilter.value.price === btn){
        store.commit('SET_TEMPORARY_FILTER', {price : ''});
    } else {
        store.commit('SET_TEMPORARY_FILTER', value);
    }
}

const resetFilter = () => {
    const resetValues = {
        price: '',
        location: '',
        city : '',
        town : '',
        gender: '',
        size: '',
    };
  store.commit('SET_TEMPORARY_FILTER', resetValues);
  emitToParnet();
};

const handleApply = async () => {
    if(isLoading.value) return;
    tempFilter.value.location = tempFilter.value.town ?  `${tempFilter.value.city}/${tempFilter.value.town}` : tempFilter.value.city



    store.commit('SET_STATUS_FILTER', tempFilter.value);
    store.commit('SET_KEYWORD_STATUS', null);
    await store.dispatch('fetchFilterData')
    // resetFilter();
    router.push('/reptile')
}

const emit = __emit
const emitToParnet = () => {
    emit('resetToggle')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["mr-[10px] px-3 min-w-[84px] h-10 flex mb-2 justify-between items-center border border-solid border-[#cccdde] rounded-[5px] cursor-pointer lg:hidden", selectedSpecies.value ? 'text-def font-bold' : '' ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSpeices()))
        }, _toDisplayString(selectedSpecies.value !== null  ? selectedSpecies.value : '개체 종'), 3),
        _createElementVNode("div", {
          class: "mr-[10px] px-3 min-w-[84px] h-10 flex justify-between items-center border border-solid border-[#cccdde] rounded-[5px] cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePopup('gender')))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(tempFilter.value.gender ? 'text-def font-bold' : '' )
          }, _toDisplayString(tempFilter.value.gender ?  tempFilter.value.gender  : '성별'), 3),
          _createElementVNode("div", _hoisted_3, _toDisplayString(tempFilter.value.toggle  && popupFilter.value ==='gender' ? `-` : '+'), 1)
        ]),
        _createElementVNode("div", {
          class: "mr-[10px] px-3 min-w-[84px] h-10 flex justify-between items-center border border-solid border-[#cccdde] rounded-[5px] cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePopup('size')))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(tempFilter.value.size ? 'text-def font-bold' : '' )
          }, _toDisplayString(tempFilter.value.size ?  tempFilter.value.size  : '크기'), 3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(tempFilter.value.toggle  && popupFilter.value ==='size' ? `-` : '+'), 1)
        ]),
        _createElementVNode("div", {
          class: "mr-[10px] px-3 min-w-[84px] h-10 flex justify-between items-center border border-solid border-[#cccdde] rounded-[5px] cursor-pointer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handlePopup('location')))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(tempFilter.value.city ? 'text-def font-bold' : '' )
          }, [
            _createElementVNode("span", null, _toDisplayString(tempFilter.value.city ?  `${tempFilter.value.city} ${tempFilter.value.town}`  : '지역'), 1)
          ], 2),
          _createElementVNode("div", _hoisted_5, _toDisplayString(tempFilter.value.toggle  && popupFilter.value ==='location' ? `-` : '+'), 1)
        ]),
        _createElementVNode("div", {
          class: "mr-[10px] px-3 min-w-[84px] h-10 flex mb-2 justify-between items-center border border-solid border-[#cccdde] rounded-[5px] cursor-pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (handlePopup('price')))
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(tempFilter.value.price ? 'text-def font-bold' : '' )
          }, _toDisplayString(tempFilter.value.price ?  tempFilter.value.price  : '가격'), 3),
          _createElementVNode("div", _hoisted_6, _toDisplayString(tempFilter.value.toggle  && popupFilter.value ==='price' ? `-` : '+'), 1)
        ]),
        _createElementVNode("button", {
          class: "w-10 h-10 rounded-md border border-solid border-[#cccdde] flex justify-center items-center sm:mr-auto mr-2",
          onClick: resetFilter
        }, _hoisted_8),
        _createElementVNode("button", {
          class: "w-28 h-10 rounded-md bg-pada text-white flex justify-center items-center font-medium text-sm",
          onClick: handleApply
        }, "적용하기")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["bg-green-00 transition-all duration-300 h-0 flex flex-col mt-5 mb-5", {
        'slide': tempFilter.value.toggle,
        'height-9rem': tempFilter.value.toggle && popupFilter.value === 'location'
      }])
      }, [
        (popupFilter.value==='gender' && tempFilter.value.toggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderArr, (btn, i) => {
                return _createElementVNode("button", {
                  key: i,
                  onClick: ($event: any) => (setGender(btn)),
                  class: _normalizeClass(["toggle", { 'selected': tempFilter.value.gender === btn }])
                }, _toDisplayString(btn), 11, _hoisted_10)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (popupFilter.value==='size' && tempFilter.value.toggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sizeArr, (btn, i) => {
                return _createElementVNode("button", {
                  key: i,
                  onClick: ($event: any) => (setSize(btn)),
                  class: _normalizeClass(["toggle", { 'selected': tempFilter.value.size === btn }])
                }, _toDisplayString(btn), 11, _hoisted_12)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (popupFilter.value==='price' && tempFilter.value.toggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priceArr, (btn, i) => {
                return _createElementVNode("button", {
                  key: i,
                  onClick: ($event: any) => (setPrice(btn)),
                  class: _normalizeClass(["toggle", { 'selected': tempFilter.value.price === btn }])
                }, _toDisplayString(btn), 11, _hoisted_14)
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (popupFilter.value==='location' && tempFilter.value.toggle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locationArr, (btn, i) => {
                return _createElementVNode("button", {
                  key: i,
                  onClick: ($event: any) => (setCity(btn)),
                  class: _normalizeClass(["toggle", { 'selected': tempFilter.value.city === btn }])
                }, _toDisplayString(btn), 11, _hoisted_16)
              }), 64))
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["bg-red-00 w-full h-full block transition-all duration-300 translate-y-0",  tempFilter.value.city && popupFilter.value==='location' ? 'block' : 'hidden' ])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationDetailArr.value, (btn, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: i,
            onClick: ($event: any) => (setTown(btn)),
            class: _normalizeClass(["mr-3 mb-3 translate-y-2 p-1", { 'text-def font-medium': tempFilter.value.town === btn }])
          }, _toDisplayString(btn), 11, _hoisted_17))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["box w-full h-auto fixed top-0 left-0", { 'off-screen': !handleMobileSpecies.value, 'on-screen': handleMobileSpecies.value }])
      }, [
        _createVNode(SpeciesFilter)
      ], 2)
    ]),
    _hoisted_18
  ], 64))
}
}

})